import { CSSProperties, ReactNode } from "react";
import { SvgIcon, TypographyProps } from "@mui/material";
import { CoreCard } from "@verity/components/core";
import styles from "./page-card.module.css";

export default function PageCard({
	className,
	bodyClassName,
	icon,
	title,
	children,
	style,
	titleVariant,
}: {
	className?: string;
	bodyClassName?: string;
	icon: ReactNode;
	title: ReactNode;
	children: ReactNode;
	style?: CSSProperties;
	titleVariant?: TypographyProps['variant'];
}) {
	return (
		<CoreCard
			useHeader
			boxShadow
			className={`${styles.card} ${className || ""}`}
			bodyClassName={bodyClassName}
			icon={<SvgIcon sx={{ color: "#42296E" }}>{icon}</SvgIcon>}
			title={title}
			style={style}
			padding={0}
			bottomPadding={0}
			titleVariant={titleVariant}
		>
			{children}
		</CoreCard>
	);
}
